import { graphql } from "./generated/index.js"

// Mutations ====================================================================

// The disconnect: both Google token rows of one membership. Runs as the
// member (heavybit_staff), whose delete permission ANDs the session's person
// and org onto this filter, so filtering on the person alone deletes exactly
// the membership's rows, with no org constant that could disagree with the
// session claim.
export const revokeGoogleTokens = graphql(`
  mutation revokeGoogleTokens($personId: Int!) {
    delete_google_access_tokens(where: { person_id: { _eq: $personId } }) {
      affected_rows
    }
    delete_google_refresh_tokens(where: { person_id: { _eq: $personId } }) {
      affected_rows
    }
  }
`)
